import type { SubscriptionStore, PaymentRetryError } from './interfaces'
import type { Subscription } from '@brighterly/lib-core-types/subscription/interfaces'
import type { Order } from '@brighterly/lib-core-types/orders/interfaces'

import { useSubscriptionListApi } from '../../api/subscription-list-api.hook'

export const actions = {
  setLoading (this: SubscriptionStore, payload: SubscriptionStore['loading']): void {
    this.loading = payload
  },
  setAvailableProductsLoading (this: SubscriptionStore, payload: SubscriptionStore['availableProductsLoading']): void {
    this.availableProductsLoading = payload
  },
  setSubscriptions (this: SubscriptionStore, payload: SubscriptionStore['subscriptions']): void {
    this.subscriptions = payload
    this.loaded = true
  },
  async ensure (this: SubscriptionStore): Promise<SubscriptionStore['subscriptions']> {
    return await useSubscriptionListApi()
  },
  clear (this: SubscriptionStore): void {
    this.subscriptions = []
    this.loaded = false
  },
  setBannerPaymentRetry (this: SubscriptionStore, val: boolean) {
    this.bannerPaymentRetry = val
  },
  setBannerPaymentRetryProcessing (this: SubscriptionStore, val: boolean) {
    this.bannerPaymentRetryProcessing = val
  },
  setPaymentRetryData (this: SubscriptionStore, data: PaymentRetryError | null) {
    this.paymentRetryData = data
  },
  setRetryPaymentModal (this: SubscriptionStore, val: boolean) {
    this.modalPaymentRetry = val
  },
  setModalRetryPaymentProcessing (this: SubscriptionStore, val: boolean) {
    this.modalPaymentRetryProcessing = val
  },
  setModalPaymentRetrySuccess (this: SubscriptionStore, val: boolean) {
    this.modalPaymentRetrySuccess = val
  },
  setModalSubscriptionPauseResume (this: SubscriptionStore, val: boolean): void {
    this.modalSubscriptionPauseResume = val
  },
  setModalSubscriptionPause (this: SubscriptionStore, val: Subscription | null): void {
    this.modalSubscriptionPause = val
  },
  setModalSubscriptionPauseDuration (this: SubscriptionStore, payload: SubscriptionStore['modalSubscriptionPauseDuration']): void {
    this.modalSubscriptionPauseDuration = payload
  },
  setModalSubscriptionPauseReason (this: SubscriptionStore, payload: SubscriptionStore['modalSubscriptionPauseReason']): void {
    this.modalSubscriptionPauseReason = payload
  },
  setModalSubscriptionFurtherPayments (this: SubscriptionStore, val: Order[] | null): void {
    this.modalSubscriptionFurtherPayments = val
  },
  setSubscription (this: SubscriptionStore, payload: Subscription | null): void {
    this.subscription = payload
  },
  setModalSubscriptionPauseSuccess (this: SubscriptionStore, val: boolean): void {
    this.modalSubscriptionPauseSuccess = val
  },
  setPauseDuration (this: SubscriptionStore, payload: SubscriptionStore['pauseDuration']): void {
    this.pauseDuration = payload
  },
  setPauseReason (this: SubscriptionStore, payload: SubscriptionStore['pauseReason']): void {
    this.pauseReason = payload
  },
  setPauseDetails (this: SubscriptionStore, payload: SubscriptionStore['pauseDetails']): void {
    this.pauseDetails = payload
  },
  setPauseContactRequest (this: SubscriptionStore, payload: SubscriptionStore['pauseContactRequest']): void {
    this.pauseContactRequest = payload
  },
  setAvailableProducts (this: SubscriptionStore, payload: SubscriptionStore['availableProducts']): void {
    this.availableProducts = payload
  },
  setAvailableProductsClear (this: SubscriptionStore): void {
    this.availableProducts = []
  },
  setUpcomingLessonsPauseStatus (this: SubscriptionStore, payload: SubscriptionStore['upcomingLessonsPauseStatus']): void {
    this.upcomingLessonsPauseStatus = payload
  },
}
